import Vue from 'vue';
export default Vue.extend({
    name: 'ssr-bootable',
    data: () => ({
        isBooted: false
    }),
    mounted() {
        window.requestAnimationFrame(() => {
            this.$el.setAttribute('data-booted', 'true');
            this.isBooted = true;
        });
    }
});
